import BigNumber from 'bignumber.js';

const metaEnv = import.meta.env;

export const IS_PROD = metaEnv.VITE_ENV === 'prod';
export const IS_STAGE = metaEnv.VITE_ENV === 'stage';
export const IS_DEV = metaEnv.VITE_ENV === 'dev';

export const IS_LOCAL =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '[::1]' ||
  import.meta.env.DEV;

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const emptyFn = () => {};

export enum MilliSeconds {
  Second = 1000,
  Minute = Second * 60,
  Hour = Minute * 60,
  Day = Hour * 24,
  Week = Day * 7,
  Month = Day * 30,
  Year = Day * 365,
}

export const ZERO = new BigNumber(0);

export const ONE = new BigNumber(1);

export const HUNDRED = new BigNumber(100);

export const THOUSAND = new BigNumber(1000);

export const DECIMAL_PLACES_SHORT = 2;

export const DEFAULT_DECIMAL_PLACES = 4;

export const DEFAULT_LONG_DECIMAL_PLACES = 8;

export const MAX_DECIMAL_PLACES = 18;

export const MAX_INTEGER_PLACES = 10;

export const BUY_MAIN_MORE_LINK = '';

export const BUY_STAKE_MORE_LINK = '';

export const LOADING_PLACEHOLDER = '-';

export const ONE_MINUTE_MS = MilliSeconds.Minute;

export const BASE_PQUEUE_CONFIG = {
  concurrency: 12,
  interval: 100,
  intervalCap: 5,
};

export const BASE_STAT_WIDTH = 320;

export const DOCS_LINK = IS_PROD
  ? 'https://docs.matstake.io'
  : 'https://stakingdocs.matchain.io';

export const TERMS_LINK =
  '/Matchain_Staking_Terms_and_Conditions_(OCA_061525).docx';

export const X_LINK = 'https://x.com/matchain_io';

export const MATCH_ID_LINK = 'https://www.matchid.ai/dashboard';

export const YOUTUBE_LINK = 'https://www.youtube.com/@MatchChain';

export const TELEGRAM_LINK = 'https://t.me/matchain_fam';

export const DISCORD_LINK = 'https://discord.com/invite/matchain';
